import last from '../array/last';
import { GroupedSuffix, NUMBERED_GRADE_RE } from './is-es-class';

// sorts nums and groups consecutive ones into range labels: [1, 3, 2] -> "1.-3. PRIM"
const toRangeLabel = (nums: number[], suffix: GroupedSuffix): string => {
    const [first, ...rest] = [...nums].sort((a, b) => a - b);

    const ranges = rest.reduce<number[][]>(
        (acc, num) => {
            const lastRange = last(acc) as number[];

            num === (last(lastRange) as number) + 1 ? lastRange.push(num) : acc.push([num]);

            return acc;
        },
        [[first as number]]
    );

    return ranges
        .map((range) => (range.length === 1 ? `${range[0]}. ${suffix}` : `${range[0]}.-${last(range)}. ${suffix}`))
        .join(', ');
};

// groups classes by suffix and returns a Map (preserving first-occurrence order) of suffix -> range label
const placeESClassesWithinRanges = (classes: MaterialClassGrade[]): Map<GroupedSuffix, string> => {
    const numbersBySuffix = classes.reduce<Map<GroupedSuffix, number[]>>((acc, { title }) => {
        const [, num, suffix] = title.match(NUMBERED_GRADE_RE) as [string, string, GroupedSuffix];

        if (!acc.has(suffix)) {
            acc.set(suffix, []);
        }

        acc.get(suffix)!.push(Number(num));

        return acc;
    }, new Map());

    return new Map(
        // @ts-ignore
        [...numbersBySuffix.entries()].map(([suffix, nums]) => [suffix, toRangeLabel(nums, suffix)])
    );
};

export default placeESClassesWithinRanges;
